"use client";

import { Breakpoints, useView } from "~/hooks/useView";
import InViewWrapper from "~/components/layout/InViewWrapper";
import { motion } from "framer-motion";
import {
  QueryClientProvider,
  useQuery,
  useQueryClient,
} from "@tanstack/react-query";
import { getSubscribers } from "~/app/api/_backend/subscribers";
import { PiSmileySadLight } from "react-icons/pi";
import React from "react";
import { FetchLoading } from "~/components/ui/FetchLoading";
import getQueryClient from "~/lib/getQueryClient";
import SubscriberCard from "~/components/ui/SubscriberCard";

export default function Page() {
  const queryClient = getQueryClient();
  return (
    <>
      <QueryClientProvider client={queryClient}>
        <Subscribers />
      </QueryClientProvider>
    </>
  );
}

const Subscribers = () => {
  const isMobileView = useView(Breakpoints.Mobile);
  const queryClient = useQueryClient();

  const { isPending, isError, data } = useQuery({
    queryKey: ["subscribers"],
    queryFn: async () => await getSubscribers(),
  });

  if (isPending) {
    return (
      <div className="flex justify-center">
        <FetchLoading />
      </div>
    );
  }

  if (isError) {
    return (
      <div className="mt-5 flex flex-col text-primary">
        <div className="mb-3 text-3xl">
          <PiSmileySadLight />
        </div>
        Nepodařilo se načíst odběratelé.{" "}
        <span
          onClick={() =>
            queryClient.invalidateQueries({ queryKey: ["subscribers"] })
          }
          className="underline transition-all hover:cursor-pointer hover:no-underline hover:brightness-75"
        >
          Načíst znova
        </span>
      </div>
    );
  }

  return (
    <>
      <section className="m-auto w-11/12 sm:w-11/12 xl:w-9/12">
        <InViewWrapper
          variant={{
            visible: {
              opacity: 1,
              transition: {
                staggerChildren: isMobileView ? 0 : 0.2,
              },
            },
            hidden: { opacity: 0 },
          }}
          Element={motion.div}
        >
          <div className="mt-12 grid grid-cols-1 gap-12 sm:grid-cols-2 2xl:grid-cols-3">
            {data?.content.map((subscriber, idx) => {
              return (
                <SubscriberCard
                  key={idx}
                  name={subscriber.name}
                  address={subscriber.address}
                  url={subscriber.url}
                  variant={{ hidden: { opacity: 0 }, visible: { opacity: 1 } }}
                />
              );
            })}
          </div>
        </InViewWrapper>
      </section>
    </>
  );
};
